<script>
    import UserContent from "../UserContent/UserContent.svelte";
   
    /** @type {Question} */
    export let question;
            
    $: cssClass = question.hasHtml ? 'question-text' : 'question-text question-text-pure';
</script>

<UserContent text={question.text} renderAsHtml={question.hasHtml} cssClass="{cssClass}" />

